import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { AddButton, EditButton } from "../components/button/CustomButton";
import CardTable from "../components/card/CardTable";
import { InputText } from "../components/form/Input";
import ModalForm from "../components/modal/ModalForm";
import { FormActionType } from "../config/global";
import { ColumnInterface } from "../components/table/typings";
import { useQueries } from "../hooks/useQueries";
import { APP_API_URL } from "../config/api";
import { useMutateWithInvalidateQueries } from "../hooks/useMutations";
import useHeaderFunctionPage from "../hooks/useHeaderFunctionPage";

export default function TypeSMSPage() {
  /**
   * Hooks
   */
  const {
    baseApiUrl,
    title,
    queryKey,
    actionForm,
    setActionForm,
    titleForm,
    setTitleForm,
    currentElement,
    setCurrentElement,
    openModal,
    setOpenModal,
    pagination,
    setPagination,
  } = useHeaderFunctionPage({ baseApiUrl: "typesms", title: "Type SMS" });

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  /**
   * Query
   */
  const { data: datas, isLoading } = useQueries(
    APP_API_URL +
      `${baseApiUrl}?pageNo=${pagination.page}&pageSize=${pagination.perPage}`,
    queryKey
  );

  /**
   * Mutation
   */
  const { mutateAsync: storeData, isLoading: storeDataIsLoading } =
    useMutateWithInvalidateQueries(
      APP_API_URL + `${baseApiUrl}-store`,
      "post",
      queryKey
    );

  const { mutateAsync: updateData, isLoading: updateIsLoading } =
    useMutateWithInvalidateQueries(
      APP_API_URL + `${baseApiUrl}/${currentElement}`,
      "put",
      queryKey
    );

  /**
   * Function
   */
  const handleSubmitAddForm = (values: any) => {
    storeData(values).then((response: any) => {
      if (response && response.data.status === "OK") {
        reset();
        toast.success("Type SMS ajouté !");
        setOpenModal(false);
      }
    });
  };

  const handleSubmitEditForm = (values: any) => {
    updateData(values).then((response: any) => {
      if (response && response.data.status === "OK") {
        reset();
        toast.success("Type SMS modifié");
        setOpenModal(false);
        setCurrentElement(0);
      }
    });
  };

  const handleCancelForm = () => {
    reset();
    setOpenModal(false);
  };

  const handleAddElement = () => {
    setTitleForm("Ajouter un type de SMS");
    setActionForm(FormActionType.ADD);
    setOpenModal(true);
    reset();
  };

  const handleEditElement = (element: any) => {
    setTitleForm("Modifier le type de SMS");
    setActionForm(FormActionType.EDIT);
    setValue("type", element.type);
    setCurrentElement(element.id);
    setOpenModal(true);
  };

  /**
   * Columns Table
   */
  const columns: ColumnInterface[] = [
    {
      title: "Type",
      key: "type",
      dataIndex: "type",
    },
    {
      title: <span style={{ textAlign: "center" }}>#</span>,
      dataIndex: "actions",
      key: "actions",
      render: (element: any) => (
        <div className="flex justify-center gap-2">
          <EditButton onClick={() => handleEditElement(element)} />
        </div>
      ),
    },
  ];

  /**
   * UI
   */
  return (
    <>
      <CardTable
        className="mx-auto md:w-2/4"
        extras={[<AddButton key={"add"} onClick={handleAddElement} />]}
        columns={columns}
        title={title}
        loading={isLoading}
        datas={datas?.data}
        pagination={pagination}
        setPagination={setPagination}
        tableClassName="text-center"
      />
      <ModalForm
        title={titleForm}
        isLoading={
          actionForm === FormActionType.ADD
            ? storeDataIsLoading
            : updateIsLoading
        }
        onClose={handleCancelForm}
        onConfirm={handleSubmit(
          actionForm === FormActionType.ADD
            ? handleSubmitAddForm
            : handleSubmitEditForm
        )}
        open={openModal}
      >
        <div className={"grid grid-cols-1"}>
          <div>
            <InputText
              placeholder={"Entrer le type de SMS"}
              label={"Type"}
              register={register}
              error={errors?.type}
              name={"type"}
            />
          </div>
        </div>
      </ModalForm>
    </>
  );
}
